import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import { Button } from '@material-ui/core';
import StartFrom from './StartFrom';
import { withRouter } from 'react-router-dom';
import ServicePopup from './ServicePopup';
import ContentLoader from 'react-content-loader';
import ProgressiveImage from 'react-progressive-image';
import { FormattedMessage } from 'react-intl';
import HOCSectionLoader from '../HOC/HOCSectionLoader.jsx';
import mail from 'assets/images/icon/mail.png';
const styles = theme => ({
    root: {
        width: '100%'
    },
    inline: {
        display: 'inline'
    },
    margin: {
        margin: theme.spacing.unit
    },
    extendedIcon: {
        marginRight: theme.spacing.unit
    },
    paper: {
        backgroundColor: theme.palette.background.paper,
        marginBottom: '10px'
    }
});

class ProviderListItem extends Component {
    constructor(props) {
        super();
        this.state = {
            redirect: false,
            servicePopup: false,
            providerData: []
        };
        this.props = {
            type: props.type,
            data: [],
            serviceId: '',
            searchedValue: ''
        };
    }

    renderDefaultAddress = addresses => {
        const addressvalue = addresses.filter(
            address => address.is_default == 1
        )[0];
        if (addressvalue) {
            return (
                <p>
                    <b>Address:</b>
                    {addressvalue && addressvalue.address_line1}
                </p>
            );
        } else {
            const addressvalue = addresses.filter(address => address)[0];
            return (
                <p>
                    <b>Address:</b>
                    {addressvalue && addressvalue.address_line1}
                </p>
            );
        }
    };

    buttonClick = (type, row) => {
        this.setState({ servicePopup: true, providerData: row });
    };

    closePopup = () => {
        this.setState({ servicePopup: false });
    };
    renderLoading = () => {
        return (
            <div className="col-xs-12 provider-list-page">
                <ContentLoader
                    height={300}
                    width={300}
                    speed={2}
                    primaryColor="#f3f3f3"
                    secondaryColor="#ecebeb"
                >
                    <rect x="0" y="13" rx="2" ry="2" width="280" height="200" />
                    <circle cx="25" cy="250" r="15" />
                    <rect
                        x="50"
                        y="240"
                        rx="4"
                        ry="4"
                        width="100"
                        height="10"
                    />
                    <rect x="50" y="260" rx="3" ry="3" width="50" height="8" />
                    <rect x="10" y="290" rx="3" ry="3" width="200" height="8" />
                </ContentLoader>
            </div>
        );
    };

    handleImageLoad = () => {
        this.setState({ imageLoaded: true });
    };
    renderProviderImage = () => {
        return (
            <div style={{ width: 150, height: 150 }}>
                <ContentLoader
                    width={150}
                    height={150}
                    speed={2}
                    primaryColor="#f3f3f3"
                    secondaryColor="#ecebeb"
                >
                    <rect x="0" y="0" rx="2" ry="2" width="150" height="150" />
                </ContentLoader>
            </div>
        );
    };
    render() {
        const { classes, data, loader } = this.props;
        if (this.state.redirect) {
            this.props.history.push({
                pathname: `/provider/detail/${this.state.providerData.key}`,
                providerId: this.state.providerData.key
            });
        }
        return (
            <div className="provider-list-page">
                <HOCSectionLoader loading={loader}>
                    <div>
                        {data.length > 0 ? (
                            data.map((provider, index) => {
                                return (
                                    <div
                                        key={index}
                                        className="dir-alp-con-right-1"
                                    >
                                        <div className="home-list-pop list-spac">
                                            <div className="col-md-3 list-ser-img">
                                                <ListItemAvatar>
                                                    <ProgressiveImage
                                                        delay={2000}
                                                        src={
                                                            provider.proImage
                                                                .medium
                                                        }
                                                        placeholder="provider-image"
                                                    >
                                                        {(src, loading) =>
                                                            loading ? (
                                                                this.renderProviderImage()
                                                            ) : (
                                                                <img
                                                                    className="provider-list-img-1"
                                                                    src={src}
                                                                    alt="an image"
                                                                />
                                                            )
                                                        }
                                                    </ProgressiveImage>
                                                </ListItemAvatar>
                                            </div>

                                            <div className="col-md-9 home-list-pop-desc inn-list-pop-desc">
                                                <ListItemText
                                                    disableTypography={true}
                                                    primary={
                                                        <React.Fragment>
                                                            {provider.isFeatured ==
                                                                1 && (
                                                                <p className="featuredPro">
                                                                    Featured
                                                                </p>
                                                            )}
                                                            <h3>
                                                                {
                                                                    provider.businessName
                                                                }
                                                            </h3>
                                                        </React.Fragment>
                                                    }
                                                    secondary={
                                                        <React.Fragment>
                                                            <h4>
                                                                {
                                                                    provider.tagline
                                                                }
                                                            </h4>
                                                            {this.renderDefaultAddress(
                                                                provider.addresses
                                                            )}
                                                            <div className="list-number">
                                                                <ul>
                                                                    <li>
                                                                        <span
                                                                            variant="outlined"
                                                                            size="large"
                                                                            color="primary"
                                                                            className={
                                                                                classes.margin +
                                                                                ' price-list'
                                                                            }
                                                                        >
                                                                            <FormattedMessage
                                                                                id="providerlist.startsfrom"
                                                                                defaultMessage="Starts From"
                                                                            />
                                                                            <StartFrom
                                                                                price={
                                                                                    provider.startFrom
                                                                                }
                                                                            />
                                                                        </span>
                                                                    </li>
                                                                    <li>
                                                                        <img
                                                                            src={
                                                                                mail
                                                                            }
                                                                            alt="mail-icon"
                                                                        />{' '}
                                                                        {
                                                                            provider.email
                                                                        }
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                            <span className="home-list-pop-rat">
                                                                {
                                                                    provider.rating
                                                                }
                                                            </span>
                                                            <div className="list-enqu-btn">
                                                                <ul>
                                                                    <li>
                                                                        <Button
                                                                            variant="contained"
                                                                            size="large"
                                                                            color="primary"
                                                                            className={
                                                                                classes.margin +
                                                                                ' btn-primary-new'
                                                                            }
                                                                            onClick={() =>
                                                                                this.buttonClick(
                                                                                    this
                                                                                        .props
                                                                                        .type,
                                                                                    provider
                                                                                )
                                                                            }
                                                                        >
                                                                            <FormattedMessage
                                                                                id="providerlist.viewdetail"
                                                                                defaultMessage="View Detail"
                                                                            />
                                                                        </Button>
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                        </React.Fragment>
                                                    }
                                                />
                                            </div>
                                        </div>
                                    </div>
                                );
                            })
                        ) : (
                            <div>
                                <div className="dir-alp-con-right-1">
                                    <div className="home-list-pop list-spac pl-4">
                                        <div className="inn-list-pop-desc">
                                            <h3>
                                                <FormattedMessage
                                                    id="providerlist.notfound"
                                                    defaultMessage="No Provider found"
                                                />
                                            </h3>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </HOCSectionLoader>
                {this.state.servicePopup && this.state.providerData && (
                    <ServicePopup
                        provider={this.state.providerData}
                        open={this.state.servicePopup}
                        close={this.closePopup}
                    />
                )}
            </div>
        );
    }
}

ProviderListItem.propTypes = {
    classes: PropTypes.object.isRequired
};

export default withRouter(withStyles(styles)(ProviderListItem));



// WEBPACK FOOTER //
// ./src/components/Providers/ProviderListItem.js